<style lang="less" scoped>
    .edit-container{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 30px 20px 120px 20px;
        overflow: auto;
        background: white;
        z-index: 999;
        .container {
          min-width: 1185px;
        }
    }
    span.required {
        color: #ed3f14;
        margin-left:3px;
    }
    .travel-title{
        display: inline-block;
        vertical-align: middle;
        font-weight: bold;
        font-size: 16px;
        margin-right: 5px;
    }
    .order-date{
        display: inline-block;
        width: 140px;
    }
    .swap-city{
        display: inline-block;
        vertical-align: middle;
        transition: .3s;
    }
    .swap-city:hover{
        color: #000;
        cursor: pointer;
        transform: scale(1.1,1.1);
    }
    .date-label{
        display: inline-block;
        vertical-align: middle;
        width: 70px;
        text-align: left;
    }
    .btn-delete {
        position: absolute;
        right: 0;
        top: 0;
    }
    .info-line {
        display: flex;
        flex-flow: column;
        padding: 10px 30px;
        margin-bottom: 20px;
        position: relative;
        
        .flex-container{
            display: flex;
            justify-content:space-between;
           .first-info {
              width: 24%;
              min-width: 290px;
           }
           .second-info {
             width: 24%;
             min-width: 290px;
           }
           .third-info {
             width: 24%;
             min-width: 290px;
           }
          .fourth-contain {
             width: 18%;
             min-width: 200px;
          }  
           
        }
        .muti-row-inline {
            display: flex;
            justify-content:space-between;
           //  align-items: center;
        }
        .row-item {
            flex: 1;
            margin-bottom: 12px;
            &.inline-info {
                display: flex;
                align-items: center;
            }
        }
    }

    .travel-order-editor .ivu-input-icon-normal+.ivu-input {
        padding-right: 22px;
    }
</style>
<template>
  <div
    v-show="show"
    class="edit-container"
  >
    <div class="container">
      <div class="line">
        <div class="error--text pl-15">
          【提示】请选择差旅事由类型
        </div>
        <div>
          <span class="travel-title">差旅事由: </span>
          <Select
            v-model="travel_order.order_type"
            style="width:82px"
          >
            <Option :value="0">
              培训学习
            </Option>
            <Option :value="1">
              团建
            </Option>
            <Option :value="3">
              商务洽谈/出行
            </Option>
            <Option :value="2">
              其他
            </Option>
          </Select>
          <space />
          <i-input
            v-model="travel_order.name"
            style="width: 300px"
          />
          <space />
          <Button
            type="primary"
            icon="md-add"
            @click="addNewItem"
          >
            添加行程
          </Button>
          <a
            class="mx-5"
            href="https://lexiangla.com/docs/63ba112c4a4511ebad0f4e567e27fc01"
            target="_blank"
          >
            <v-icon
              color="primary"
              small
            >
              mdi-file-document-outline
            </v-icon>
            超有爱差旅标准
          </a>
          <Button
            class="float-right"
            type="warning"
            icon="md-close"
            @click="hideEditor"
          >
            关闭
          </Button>
        </div>
      </div>
      <v-card
        v-for="(item, index) in travel_order.items"
        :key="index"
        class="info-line"
        outlined
      >
        <v-btn
          v-if="index > 0"
          class="btn-delete"
          icon
          color="grey"
          x-small
          @click="delItem(item, index)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="flex-container my-2">
          <v-card
            class="first-info"
            outlined
          >
            <v-list dense>
              <v-list-item>
                <v-list-item-subtitle>
                  <RadioGroup
                    v-model="item.passage_type"
                    class="row-item"
                    @on-change="clearTravelInfo(item)"
                  >
                    <Radio :label="1">
                      <span>单程</span>
                    </Radio>
                    <Radio :label="2">
                      <span>往返</span>
                    </Radio>
                    <Radio
                      :label="0"
                      :disabled="!item.need_hotel"
                    >
                      <span>不需要预订</span>
                    </Radio>
                  </RadioGroup>
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>出行方式</v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <RadioGroup 
                      v-model="item.travel_type"
                    >
                      <Radio
                        :label="0"
                        :disabled="!item.passage_type"
                      >
                        <span>飞机</span>
                      </Radio>
                      <Radio
                        :label="1"
                        :disabled="!item.passage_type"
                      >
                        <span>火车（含高铁/动车）</span>
                      </Radio>
                    </RadioGroup>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <CitySelector
                      v-model="item.city_from"
                      :disabled="!item.passage_type"
                      size="small"
                      placeholder="出发城市"
                      style="width: 100px; margin-right:10px"
                    />
                    <!-- <span>*</span> -->
                    <DatePicker
                      :disabled="!item.passage_type"
                      class="order-date"
                      size="small"
                      :value="item.depart_date"
                      type="date"
                      placeholder="出发日期"
                      @on-change="function(date){itemDateChange(item, 'depart_date', date)}"
                    />
                    <span class="required">*</span>
                  </v-list-item-subtitle>

                  <v-list-item-subtitle>
                    <CitySelector
                      v-model="item.city_to"
                      :disabled="!item.passage_type"
                      size="small"
                      placeholder="到达城市"
                      style="width: 100px; margin-right:10px"
                    />
                    <DatePicker
                      :disabled="!item.passage_type || item.passage_type === 1"
                      class="order-date"
                      size="small"
                      :value="item.return_date"
                      type="date"
                      placeholder="返程日期"
                      @on-change="function(date){itemDateChange(item, 'return_date', date)}"
                    />
                    <span class="required">*</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    去程关键词<span class="required">*</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <i-input
                      v-model="item.depart_key_words"
                      :disabled="!item.passage_type"
                      :placeholder="!item.travel_type ? '航班号/航班时间/偏好时间段/航司/机型/起降机场等' : '车次/车次时间/偏好时间段/始发站/终点站等'"
                      type="textarea"
                      style="width: 250px"
                    />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    返程关键词<span class="required">*</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <i-input
                      v-model="item.return_key_words"
                      :disabled="!item.passage_type || item.passage_type === 1"
                      type="textarea"
                      :placeholder="!item.travel_type ? '航班号/航班时间/偏好时间段/航司/机型/起降机场等' : '车次/车次时间/偏好时间段/始发站/终点站等'"
                      style="width: 250px"
                    />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        
          <v-card
            class="second-info"
            outlined
          >
            <v-list dense>
              <v-list-item>
                <RadioGroup
                  v-model="item.need_hotel"
                  @on-change="clearHotelInfo(item)"
                >
                  <Radio
                    class="row-item"
                    :label="1"
                  >
                    <span>预订酒店</span>
                  </Radio>
                  <Radio
                    class="row-item"
                    :label="0"
                    :disabled="!item.passage_type"
                  >
                    <span>不需要预订</span>
                  </Radio>
                </RadioGroup>
              </v-list-item>
              <v-list-item>
                <v-list-item-subtitle>
                  <span class="mr-3">
                    入住日期
                  </span>
                  <DatePicker
                    :disabled="!item.need_hotel"
                    class="order-date"
                    size="small"
                    :value="item.check_in_date"
                    type="date"
                    @on-change="function(date){itemDateChange(item, 'check_in_date', date)}"
                  />
                  <span class="required">*</span>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-subtitle>
                  <span class="mr-3">
                    离店日期
                  </span>
                  <DatePicker
                    :disabled="!item.need_hotel"
                    class="order-date"
                    size="small"
                    :value="item.check_out_date"
                    type="date"
                    @on-change="function(date){itemDateChange(item, 'check_out_date', date)}"
                  />
                  <span class="required">*</span>
                </v-list-item-subtitle>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    关键词<span class="required">*</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <i-input
                      v-model="item.hotel_key_words"
                      :disabled="!item.need_hotel"
                      placeholder="酒店名/地址/地标/商圈/地铁线等"
                      type="textarea"
                      style="width: 240px"
                    />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        
          <v-card
            class="third-info"
            outlined
          >
            <v-subheader class="justify-center">
              预算
            </v-subheader>
            <Row
              v-for="(c_item,c_index) in item.budgets" 
              :key="c_index"
              style="margin:10px 0"
            >
              <Col span="9" />
              <p style="margin:0px 10px;line-height:32px;text-align:right">
                {{ c_item.text }}
              </p>
              </Col>
              <Col span="15" />
              <Input
                v-model="c_item.budget_amount"
                type="number"
                style="width:90%"
                placeholder="请输入金额"
                @on-change="numberChange(c_item)"
              /> 
              <span class="required">*</span>
              </Col> 
            </Row>
            <p class="error--text text-center text-no-wrap">
              【提示】该行程不涉及的费用类别，可填0
            </p>
          </v-card>

          <v-card
            class="fourth-contain"
            outlined
          >
            <v-subheader>备注</v-subheader>
            <v-list-item>
              <i-input
                v-model="item.remark"
                type="textarea"
                size="small"
                :rows="8"
                placeholder="任何个性化需求或反馈，请在此补充"
              />
            </v-list-item>
          </v-card>
        </div>
        <v-divider class="my-3" />
        <div class="my-2">
          <v-card
            v-for="(passenger, passengerIndex) in item.passengers"
            :key="passengerIndex"
            class="flex-container mb-3 pa-4"
            outlined
          >
            <div class="first-info">
              <div class="row-item inline-info">
                <div class="mr-2">
                  姓名
                </div>
                <CustomerSelector
                  v-model="passenger.account"
                  size="small"
                  :selected="passenger.customer_id > 0"
                  placement="bottom-start"
                  @cancel-select="function () { cancelSelect(passenger) }"
                  @select="function(customer){customerSelect(passenger, customer)}"
                />
                <span class="required">*</span>
              </div>
              <div class="row-item inline-info">
                <div class="mr-2">
                  性别
                </div>
                <RadioGroup v-model="passenger.gender">
                  <Radio :label="1">
                    <span>男</span>
                  </Radio>
                  <Radio :label="0">
                    <span>女</span>
                  </Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="second-info">
              <div class="row-item inline-info">
                <div style="margin-right:10px">
                  电话
                </div>
                <i-input
                  v-model="passenger.mobile"
                  style="width: 200px"
                  size="small"
                  icon="ios-phone-portrait"
                />
                <span class="required">*</span>
              </div>
              <div class="row-item inline-info">
                <div style="margin-right:10px">
                  邮箱
                </div>
                <i-input
                  v-model="passenger.email"
                  style="width:200px"
                  size="small"
                  icon="md-mail"
                />
              </div>
            </div>
            <div class="third-info">
              <div class="row-item inline-info">
                <Select
                  v-model="passenger.id_type"
                  style="width: 90px; margin-right: 10px;"
                  size="small"
                  @on-change="queryIdInfo(passenger)"
                >
                  <Option :value="1">
                    身份证
                  </Option>
                  <Option :value="0">
                    护照
                  </Option>
                  <Option :value="2">
                    港澳台居民居住证
                  </Option>
                  <Option :value="3">
                    台胞证
                  </Option>
                  <Option :value="4">
                    回乡证
                  </Option>
                </Select>
                <div style="position:relative">
                  <i-input
                    v-model="passenger.id_number"
                    style="width:175px"
                    size="small"
                    placeholder="证件号"
                    icon="ios-person"
                  />
                </div>
                <span class="required">*</span>
              </div>
              <div class="error--text">
                【提示】需与乘{{ item.travel_type === 1 ? '车' : '机' }}时出示证件一致
              </div>
              <div class="error--text text-no-wrap">
                【提示】{{ item.travel_type === 1 ? '台籍乘客请使用台胞证购票' : '港澳台同胞请使用回乡证,台胞证购票' }}
              </div>
            </div>
            <div class="fourth-contain">
              <div class="row-item inline-info">
                <div style="margin-right: 10px;margin-left:8px">
                  出生日期
                </div>
                <DatePicker
                  :disabled="passenger.id_type === 1"
                  class="order-date"
                  size="small"
                  :value="passenger.birthday"
                  type="date"
                  style="width: 110px"
                  @on-change="function(date){itemDateChange(passenger, 'birthday', date)}"
                />
                <span class="required">*</span>
              </div>
              <div class="row-item inline-info">
                <div style="margin-right:10px;margin-left: 8px">
                  国籍
                </div>
                <RegionSelector
                  v-model="passenger.region"
                  :disabled="passenger.id_type !== 0"
                  style="width: 140px"
                />
                <span class="required">*</span>
              </div>
              <v-btn
                v-if="passengerIndex > 0"
                class="btn-delete"
                icon
                color="grey"
                x-small
                @click="deletePassenger(index, passengerIndex)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card>
          <Button
            size="small"
            icon="md-add"
            type="primary"
            @click="addPassenger(index)"
          >
            添加同行人
          </Button>
        </div>
      </v-card>
      <div class="line text-right">
        <Button
          size="large"
          type="primary"
          :loading="saving"
          @click="save()"
        >
          保存
        </Button>
      </div>
    </div>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  import CustomerSelector from './customer_selector';
  import CitySelector from './city_selector';
  import RegionSelector from './region_selector';
  import { budget_types } from '../mixins/travel_order_base'

  export default {
    components: { CustomerSelector, CitySelector, RegionSelector },
    data() {
      return {
        show: false,
        travel_order: {
          id: 0,
          customer_id: 0,
          name: '',
          order_type: -1,
          items: []
        },
        new_travel_order: {
          id: 0,
          customer_id: 0,
          name: '',
          order_type: -1,
          items: []
        },
        new_item: {
          id: 0,
          travel_order_id: 0,
          travel_type: 0,
          passage_type: 2,
          depart_date: '',
          return_date: '',
          check_in_date: '',
          check_out_date: '',
          depart_key_words: '',
          return_key_words: '',
          hotel_key_words: '',
          city_from: '',
          city_to: '',
          need_hotel: 1,
          remark: '',
          passengers: [{
            id_type: 1,
            account: '',
            customer_id: 0,
            mobile: '',
            email: '',
            id_number: '',
            gender: 1,
            birthday: '',
            region: ''
          }]
        },
        saving: false,
        deleting_index: 0
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      numberChange(c_item) {
        const dig_index = c_item.budget_amount.indexOf('.')
        if (dig_index === -1) {
          return 
        }
        // console.log('asdasdasdasd')
        setTimeout(() => {
          c_item.budget_amount = c_item.budget_amount.slice(0, dig_index + 3)
        }, 50);
      },
      // deleteTravelItem (index) {
      //     const travelOrderItem = this.travel_order.items[index]
      //     if (travelOrderItem.id) {
      //         Util.ajax.post(Util.api.delete_travel_order_item, {id: travelOrderItem.id}).then(res => {
      //             if (res.data.code !== 1) {
      //                 this.$Modal.warning({
      //                     title: '错误',
      //                     content: res.data.msg
      //                 });
      //             }
      //         }).catch(e => {
      //             this.$Modal.warning({
      //                 title: '错误',
      //                 content: e.message
      //             });
      //         })
      //     }
      //     this.travel_order.items.splice(index, 1)
      // },
      clearTravelInfo(item) {
        if (!item.passage_type) {
          item.travel_type = 0
          item.city_from = ''
          item.city_to = ''
          item.depart_date = ''
          item.return_date = ''
          item.depart_key_words = ''
          item.return_key_words = ''
        }
        if (item.passage_type === 1) {
          item.return_date = ''
          item.return_key_words = ''
        }
      },
      clearHotelInfo(item) {
        if (!item.need_hotel) {
          item.check_in_date = ''
          item.check_out_date = ''
          item.hotel_key_words = ''
        }
      },
      queryIdInfo(passenger) {
        const customerId = passenger.customer_id
        if (customerId && passenger.id_type === 1) {
          Util.ajax.get(Util.api.customer_detail, {
            params: customerId
          }).then(res => {
            if (res.data.code === 1) {
              passenger.id_number = res.data.data.customer.id_number
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          })
        } else {
          passenger.id_number = ''
        }
        if (passenger.id_type === 1) {
          passenger.birthday = ''
          passenger.region = ''
        } else if (passenger.id_type) {
          passenger.region = ''
        }
      },
      cancelSelect(passenger) {
        passenger.customer_id = 0
        passenger.id_number = ''
        passenger.email = ''
        passenger.account = ''
        passenger.mobile = ''
      },
      editNew() {
        const customer = this.cur_customer;
        const item = this.new_item;
        item.passengers[0].account = customer.account;
        item.passengers[0].customer_id = customer.id;
        item.passengers[0].mobile = customer.mobile;
        item.passengers[0].email = customer.email;
        item.passengers[0].id_number = customer.id_number;
        item.passengers[0].gender = customer.gender * 1;
        this.edit(Util.clone(this.new_travel_order));
      },
      edit(travel_order) {
        // 生成数据
        this.travel_order = JSON.parse(JSON.stringify(travel_order));
        if (travel_order.items.length === 0) {
          this.addNewItem();
        }
        // 
        this.travel_order.items.forEach((travel_order_item) => {
          // 是否需要酒店
          travel_order_item.need_hotel = travel_order_item.need_hotel ? 1 : 0
          // 
          const budgets_clone = travel_order_item.budgets
          this.$set(travel_order_item, 'budgets', []) 
          const budgets_hash = (budgets_clone || []).reduce((total, item) => {
            total[item.budget_type] = item.budget_amount
            return total
          }, {})
          const _budget_types = JSON.parse(JSON.stringify(budget_types))
          _budget_types.forEach((item, index) => {
            if (budgets_hash[item.budget_type]) {
              this.$set(travel_order_item.budgets, index, {
                ...item,
                budget_type:item.budget_type,
                budget_amount:budgets_hash[item.budget_type],
              })  
            } else {
              this.$set(travel_order_item.budgets, index, item)
            // this.travel_order.budgets.push(item)
            }
          })

        })

        this.show = true;
      },
      addNewItem() {
        const customer = this.cur_customer;
        const item = this.new_item
        // 添加默认乘客--自己
        if (!item.passengers[0].account) {
          item.passengers[0].account = customer.account;
          item.passengers[0].customer_id = customer.id;
          item.passengers[0].mobile = customer.mobile;
          item.passengers[0].email = customer.email;
          item.passengers[0].id_number = customer.id_number;
          item.passengers[0].gender = customer.gender * 1;
        }
        item.budgets = Util.clone(budget_types)
        this.travel_order.items.push(Util.clone(item));
      },
      addPassenger(index) {
        this.travel_order.items[index].passengers.push({
          id_type: 1,
          account: '',
          customer_id: 0,
          mobile: '',
          email: '',
          id_number: '',
          gender: 1,
          region: '',
          birthday: ''
        })
      },
      deletePassenger(itemIndex, passengerIndex) {
        const passenger = this.travel_order.items[itemIndex].passengers[passengerIndex]
        if (passenger.id) {
          Util.ajax.post(Util.api.delete_travel_order_item_customer, {id: passenger.id}).then(res => {
            if (res.data.code !== 1) {
              this.$Modal.warning({
                title: '错误',
                content: res.data.msg
              });
            }
          }).catch(e => {
            this.$Modal.warning({
              title: '错误',
              content: e.message
            });
          })
        }
        this.travel_order.items[itemIndex].passengers.splice(passengerIndex, 1)
      },
      hideEditor() {
        this.show = false;
      },
      customerSelect(passenger, customer) {
        passenger.account = customer.account;
        passenger.customer_id = customer.id;
        passenger.mobile = customer.mobile;
        passenger.email = customer.email;
        passenger.id_number = customer.id_number;
        passenger.id_type = 1
        passenger.gender = customer.gender * 1;
      },
      swapCity(item) {
        let tmp = item.city_from;
        item.city_from = item.city_to;
        item.city_to = tmp;
        tmp = null;
      },
      itemDateChange(item, key, date) {
        if (item.need_hotel) {
          if (key === 'depart_date') {
            item.check_in_date = date
          } else if (key === 'return_date') {
            item.check_out_date = date
          }
        }
        item[key] = date;
      },
      delItem(item, index) {
        if (item.id) {
          this.deleting_index = index;
          Util.ajax.post(Util.api.delete_travel_order_item, {
            id: item.id
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.deleting_index = 0;
            if (res.code === 1) {
              this.travel_order.items.splice(index, 1);
            } else {
              this.$Modal.warning({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.deleting_index = 0;
            this.$Modal.warning({
              title: '错误',
              content: e.message
            });
          });
        } else {
          this.travel_order.items.splice(index, 1);
        }
      },
      checkValid() {
        let err_msg = '';
        if (!this.travel_order.name.trim()) {
          err_msg += `<p>差旅事由名称不能为空</p>`;
        }
        if (this.travel_order.order_type === -1) {
          err_msg += `<p>请选择[差旅事由类型]</p>`;
        }
        this.travel_order.items.forEach((item, index) => {
          if (item.passage_type) {
            if (!item.depart_date) {
              err_msg += `<p>行程${index + 1} - 请选择[出发日期]</p>`;
            }
            if (!item.city_from.trim()) {
              err_msg += `<p>行程${index + 1} - 请选择[出发城市]</p>`;
            }
            if (!item.city_to.trim()) {
              err_msg += `<p>行程${index + 1} - 请选择[到达城市]</p>`;
            }
            if (!item.depart_key_words.trim()) {
              err_msg += `<p>行程${index + 1} - 请填写[去程关键词]</p>`;
            }
            if (item.passage_type === 2) {
              if (!item.return_date) {
                err_msg += `<p>行程${index + 1} - 请选择[返程日期]</p>`;
              }
              if (!item.return_key_words.trim()) {
                err_msg += `<p>行程${index + 1} - 请填写[返程关键词]</p>`;
              }

            }
          }
          /* 预算 */
          item.budgets.forEach(item => {
            if (!item.budget_amount) {
              err_msg += `<p>行程${index + 1} - 请填写[${item.text}]金额</p>`;
            }
          })
          if (item.need_hotel) {
            if (!item.check_in_date) {
              err_msg += `<p>行程${index + 1} - 请选择[入住日期]</p>`;
            }
            if (!item.check_out_date) {
              err_msg += `<p>行程${index + 1} - 请选择[离店日期]</p>`;
            }
            if (!item.hotel_key_words.trim()) {
              err_msg += `<p>行程${index + 1} - 请填写[酒店关键词]</p>`;
            }
          }
          
          // if (!item.passengers.length) {
          //     err_msg += `<p>行程${index+1} - 请添加至少1名乘客</p>`;
          // }
          item.passengers.forEach((passenger, passengerIndex) => {
            if (!passenger.account) {
              err_msg += `<p>行程${index + 1} - 乘客${passengerIndex + 1} - 请填写[姓名]</p>`;
            }
            if (!passenger.id_number.trim()) {
              err_msg += `<p>行程${index + 1} - 乘客${passengerIndex + 1} - 请填写[证件信息]</p>`;
            } else {
              if (passenger.id_type === 1 && passenger.id_number.length >= 15) {
                if (passenger.id_number.indexOf('*') === -1 && !Util.IDCheck(passenger.id_number)) {
                  err_msg += `<p>行程${index + 1} - 乘客${passengerIndex + 1} - [身份证]填写有误, 请仔细检查</p>`;
                }
              }
            }
            if (passenger.id_type !== 1) {
              if (!passenger.birthday.trim()) {
                err_msg += `<p>行程${index + 1} - 乘客${passengerIndex + 1} - 请填写[出生日期]</p>`;
              }
              if (!passenger.id_type) {
                if (!passenger.region.trim()) {
                  err_msg += `<p>行程${index + 1} - 乘客${passengerIndex + 1} - 请填写[国籍]</p>`;
                }
              }
            }
            if (!passenger.mobile.trim()) {
              err_msg += `<p>行程${index + 1} - 乘客${passengerIndex + 1} - 请填写[手机号码]</p>`;
            }
          })
        });
        if (err_msg) {
          this.$Modal.warning({title: '信息校验有误', content: err_msg});
          return false;
        }
        return true;
      },
      save() {
        if (!this.checkValid()) return;
        if (this.saving) return;
        this.saving = true;
        // const save_travel_order = this.travel_order
        // save_travel_order.items.forEach(item => {
        //     if (!item.passage_type) {
        //         item.passengers = []
        //     }
        // })
        const _params = JSON.parse(JSON.stringify(this.travel_order))
        _params.items.forEach((item) => {
          // 是否需要酒店
          item.need_hotel = !!item.need_hotel
          // 预算
          item.budgets = item.budgets.map(({budget_type, budget_amount}) => ({
            budget_type,
            budget_amount
          }))
        })
        Util.ajax.post(Util.api.update_travel_order, _params).then((response) => {
          return response.data;
        }).then((res) => {
          this.saving = false;
          if (res.code === 1) {
            const data = res.data;
            this.$emit('update', data.order);
            this.hideEditor();
          } else {
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.saving = false;
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      }
    }
  }
</script>
